import { frameworksApi, storyFrameworkRef } from '../api/frameworks';
import { plotDossiersApi } from '../api/plotDossiers';

/**
 * Offer 1 (#1242): create a custom Framework from the doc's scenes and
 * set it on the book. Does not write Workshop fills and does not call
 * accept_beat. Purpose text is catalog purpose, not a sequence fill.
 */
export function storyOrderSpineBody(spine, frameworkName) {
  return {
    framework_name: frameworkName,
    description: spine?.description || '',
    genre_tag: spine?.genre_tag || null,
    thin_genre: false,
    beats: (spine?.beats || []).map((beat) => ({
      name: beat.name,
      act: Number(beat.act),
      purpose: beat.purpose,
      cite_kind: 'general',
      cite_titles: [],
    })),
    acts: (spine?.acts || []).map((act) => ({
      number: act.number,
      name: act.name,
      purpose: act.purpose || '',
    })),
    tracks: [],
    tropes: [],
  };
}

export async function applyDocsStoryOrderSpine({ storyId, spine }) {
  if (!storyId) {
    throw new Error('Open a book before this can become the book\u2019s Framework.');
  }
  if (!spine?.beats?.length) {
    throw new Error('These scenes have names and no purpose lines.');
  }
  const baseName = (spine.framework_name || 'From your story order').trim();
  let saved = null;
  let lastError = null;
  for (let attempt = 0; attempt < 4; attempt += 1) {
    const frameworkName = attempt === 0
      ? baseName
      : `${baseName} ${attempt + 1}`.slice(0, 100);
    try {
      saved = await frameworksApi.createCustom(storyOrderSpineBody(spine, frameworkName));
      lastError = null;
      break;
    } catch (err) {
      lastError = err;
      if (err?.status !== 409) throw err;
    }
  }
  if (!saved) throw lastError;
  await plotDossiersApi.setFramework(storyId, storyFrameworkRef(saved));
  return saved;
}
